import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import Expanded from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_maximise.svg';
import Collapsed from '@3plearning/3p-teacheradmin-assets/assets/UPF/icons/ico_minimise.svg';
import css from './assignments-action-bar.scss';
import useAssignmentsActionBar from './hooks/use-assignments-action-bar';

const AssignmentsActionBar = (props) => {
  const { isCollapsed, toggleIsCollapsed } = useAssignmentsActionBar();

  return (
    <div
      className={`${css.footer} ${
        isCollapsed ? css.collapsedContainer : css.expandedContainer
      }`}
    >
      {isCollapsed && (
        <div
          className={css.icon}
          role="button"
          data-testid="expand-action-bar-button"
          tabIndex="-1"
          onClick={toggleIsCollapsed}
        >
          <Isvg src={Expanded} cacheGetRequests />
        </div>
      )}
      <div>{props.children}</div>
      {!isCollapsed && (
        <div
          className={`${css.icon} ${css.iconCollapsed}`}
          role="button"
          data-testid="collapse-action-bar-button"
          tabIndex="-1"
          onClick={toggleIsCollapsed}
        >
          <Isvg src={Collapsed} cacheGetRequests />
        </div>
      )}
    </div>
  );
};

AssignmentsActionBar.propTypes = {
  children: PropTypes.object
};

export default AssignmentsActionBar;



// WEBPACK FOOTER //
// ./components/assignments-action-bar/assignments-action-bar.js